export var colors = {
  // Anyfin Design System Colors
  birodoGreen: "#1C4233",
  spruceGreen: "#05663D",
  slimlimeGreen: "#B2EBC4",
  exoticOrange: "#FF5C38",
  blushPink: "#F7DBD6",
  black: "#000000",
  white: "#FFFFFF",
  edgarWhite: "#EDEDED",
  silverGrey: "#C7C7C7",
  brickRed: "#bf2600",
  porcelainPink: "#ffbdad",
  marigoldYellow: "#ff8b00",
  paperYellow: "#fff0b3",
  ultraLightPink: "#FDEEF2",

  // old colors:
  coreWhite: "#ffffff",

  darkGrey: "#2C2D3A",
  coreGrey: "#545565",
  lightGrey: "#DCDCE0",
  ultraLightGrey: "#f4f4f6",

  darkNavy: "#00003d",
  coreNavy: "#0a1668",
  lightNavy: "#384aae",
  paleNavy: "#E8E9F5",

  corePink: "#faa5aa",
  lightPink: "#fed7dc"
};